import { getEditorialRequestRevision } from 'app/services/editorialRequest.service';
import { EDITORIAL_REVIEWER_UI_READY } from 'app/config/editorialReviewer.config';
import axios from 'axios';

export function editorialRequest(action, method, ...args) {
  if (!['read', 'write'].includes(action) || !['get', 'post', 'put', 'patch', 'delete'].includes(method)) throw new Error('INVALID_EDITORIAL_REQUEST');
  if (!EDITORIAL_REVIEWER_UI_READY) return axios[method](...args);
  const configIndex = ['get', 'delete'].includes(method) ? 1 : 2;
  args[configIndex] = { ...args[configIndex], editorialAction: action, editorialRevision: getEditorialRequestRevision() };
  return axios[method](...args);
}
